<template>
  <div>
    <!-- TODO: обернуть каждое поле в свою форму валидировать форму огрн при изменении типа инн юл/ип -->
    <v-form ref="form" v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              :rules="[rules.required('Введите название организации'), rules.max320]"
              v-model="companyData.name"
              outlined
              label="Название организации"
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :rules="[rules.required('Введите ИНН'), rules.inn]"
              v-model="companyData.inn"
              outlined
              label="ИНН"
              v-mask="['##########', '############']"
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :rules="[rules.required('Введите ' + ogrnLabel), rules.ogrn]"
              v-model="companyData.ogrn"
              outlined
              :label="ogrnLabel"
              v-mask="['#############', '###############']"
              dense
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <div class="d-flex align-center btn">
      <v-btn @click="goBack" text class="btn-back" style="margin-left: auto; margin-right: 20px"
        >Вернуться к поиску</v-btn
      >
      <v-btn @click="setNewCompany" :disabled="!valid" x-large color="primary" class="btn-ok">Продолжить</v-btn>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { validateInn, validateOgrn } from "@/utils/helpers";
import { mapGetters, mapState } from "vuex";

export default {
  directives: { mask },
  data() {
    return {
      companyData: {
        name: "",
        ogrn: "",
        inn: "",
        isNewCompany: true,
      },
      valid: false,
      rules: {
        required: (msg) => (v) => !!v || msg,
        max320: (v) => v.length < 320 || "Слишком длинное название",
        inn: (v) => (validateInn(v) && this.isInnMatchOgrn) || "Введите корректный ИНН",
        ogrn: (v) => (validateOgrn(v) && this.isOgrnMatchInn) || "Введите корректный " + this.ogrnLabel,
      },
    };
  },
  // для повторной валидации в случае изменения типа инн / огрн
  watch: {
    isInnUl() {
      if (this.companyData.ogrn) {
        this.$refs.form.validate();
      }
    },
    isInnIp() {
      if (this.companyData.ogrn) {
        this.$refs.form.validate();
      }
    },
    isOgrn() {
      if (this.companyData.inn) {
        this.$refs.form.validate();
      }
    },
    isOgrnip() {
      if (this.companyData.inn) {
        this.$refs.form.validate();
      }
    },
  },
  computed: {
    ...mapState("profile", ["inn", "company"]),

    isInnIp() {
      return !!this.companyData.inn && this.companyData.inn.length === 12;
    },
    isInnUl() {
      return !!this.companyData.inn && this.companyData.inn.length === 10;
    },
    isOgrn() {
      return !!this.companyData.ogrn && this.companyData.ogrn.length === 13;
    },
    isOgrnip() {
      return !!this.companyData.ogrn && this.companyData.ogrn.length === 15;
    },
    isInnMatchOgrn() {
      return this.isOgrn ? this.isInnUl : this.isOgrnip ? this.isInnIp : true;
    },
    isOgrnMatchInn() {
      return this.isInnUl ? this.isOgrn : this.isInnIp ? this.isOgrnip : true;
    },
    ogrnLabel() {
      return this.isInnIp ? "ОГРНИП" : this.isInnUl ? "ОГРН" : "ОГРН/ОГРНИП";
    },
  },
  methods: {
    setNewCompany() {
      this.$emit("set-new-company", this.companyData);
      this.$emit("go-back");
    },
    goBack() {
      this.$emit("go-back");
    },
  },
  mounted() {
    this.companyData.inn = this.company.inn;
    this.companyData.ogrn = this.company.ogrn;
    this.companyData.name = this.company.name;
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .btn {
    flex-direction: column;
  }
  .btn-back {
    margin-right: 0px;
    margin: 0 auto;
    margin-left: inherit;
  }
  .btn-ok {
    margin: 0 auto;
    margin-left: inherit;
  }
}
</style>
